import { CheckRoundIcon } from '@farol-ds/react'
import { BoxLockVariationType } from '@jusbrasil-web/shared-apollo-client/types'

export function getModalContentByLockVariationType(lockVariationType: BoxLockVariationType) {
  switch (lockVariationType) {
    case BoxLockVariationType.CaseTrackingBgCheckFromBgCheckOffersLock:
      return {
        title: 'Atualize seu plano para entender a situação atual do seu processo',
        buttonText: 'Continuar',
        subtitle:
          'Seu plano permite você <strong>consultar processos de outras pessoas</strong>, atualize seu plano para <strong>entender a situação atual do seu processo</strong>.',
        benefits: [
          {
            iconType: CheckRoundIcon,
            name: 'Acesso a explicação clara e sem termos jurídicos sobre a situação do processo',
          },
          {
            iconType: CheckRoundIcon,
            name: 'Notificações sempre que seu processo tiver novidades',
          },
          {
            iconType: CheckRoundIcon,
            name: 'Orientação sobre os possíveis próximos passos do seu processo',
          },
        ],
      }
    case BoxLockVariationType.CaseTrackingBgCheckFromLawsuitOffersLock:
      return {
        title: 'Atualize seu plano para consultar processos de outras pessoas',
        buttonText: 'Conhecer planos',
        subtitle:
          'Seu plano permite <strong>acompanhar e entender seus processos</strong>. Para <strong>consultar processos de outras pessoas</strong>, atualize seu plano.',
        benefits: [
          {
            iconType: CheckRoundIcon,
            name: 'Encontre processos de outras pessoas em todos os tribunais ',
          },
          { iconType: CheckRoundIcon, name: 'Veja os motivos dos processos em linguagem simples' },
          {
            iconType: CheckRoundIcon,
            name: 'Saiba os detalhes de cada processo com um resumo simplificado',
          },
        ],
      }
  }
}
